import { getExperimentsContext } from './ExperimentsContext';
import { ExperimentsFlags } from './types';

/**
 * Получить значение флага эксперимента
 */
function getExperimentFlag<K extends keyof ExperimentsFlags>(name: K): ExperimentsFlags[K];

/**
 * Проверить значение флага эксперимента на соответствие ожидаемому
 */
function getExperimentFlag<K extends keyof ExperimentsFlags>(name: K, value: ExperimentsFlags[K]): boolean;

/**
 * Реализация
 */
function getExperimentFlag<K extends keyof ExperimentsFlags>(
    name: K,
    value?: ExperimentsFlags[K]
): ExperimentsFlags[K] | boolean {
    const flagValue = getExperimentsContext().experimentsFlags[name];

    if (arguments.length === 1) {
        return flagValue;
    }

    return flagValue === value;
}

export { getExperimentFlag };
